import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { BgVideo } from '../BgVideo/BgVideo';
import { Message } from '../Message/Message';

import styles from './MessagesList.module.css';

export const MessagesList = ({ messages, speed }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.messagesWrapper}>
        <TransitionGroup className={styles.messages}>
          {messages.length > 0 &&
            messages.map((item, i) => {
              const msg = item.message;
              const key = item.id;

              return (
                <CSSTransition
                  key={item.UUID}
                  timeout={speed}
                  classNames="position"
                  // appear={true}
                >
                  <Message
                    key={key}
                    message={msg}
                    rotateSign={item.rotateSign}
                    speed={speed}
                    randomDelay={item.randomDelay}
                  />
                </CSSTransition>
              );
            })}
        </TransitionGroup>
      </div>

      <BgVideo />
    </div>
  );
};
